@if (isLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
}
<rds-header minimalMargins>
  <!--
    On compact viewports the logo and its dividers give way to the panel name
    alone, so the title still fits next to the actions on a phone.

    Hidden with a class rather than removed with @if. rds-header has only named
    projection slots and no catch-all, and wrapping these three nodes in an @if
    stopped them being projected at all — the logo then disappeared on desktop
    too, not just on mobile.
  -->
  <rds-divider
    rds-header-start-divider
    class="native-menu"
    [class.d-none]="isCompact()"></rds-divider>
  <rds-header-app-name
    routerLink="/dashboard/rooms"
    [class.d-none]="isCompact()">
    <img
      class="header-logo"
      ngSrc="assets/bookly-logo.svg"
      width="116"
      height="32"
      alt="bookly-logo" />
  </rds-header-app-name>
  <rds-divider
    rds-header-start-divider
    [class.d-none]="isCompact()"></rds-divider>
  <rds-header-app-name>{{ title() }}</rds-header-app-name>
  <rds-divider rds-header-end-divider></rds-divider>
  <rds-header-actions>
    <bsh-notifications-dropdown></bsh-notifications-dropdown>
    @if (user && !isCompact()) {
      <div rdsDropdown [autoClose]="true" placement="bottom-right">
        <rds-avatar class="dropdown-toggle" rdsDropdownToggle trigger="click">
          @if (user.picture) {
            <img
              rds-avatar-image
              [ngSrc]="user.picture"
              fill
              alt="User avatar"
              referrerpolicy="no-referrer" />
          } @else {
            <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
          }
        </rds-avatar>
        <div class="dropdown" *rdsDropdownMenu>
          <span class="dropdown__name">
            {{ user.name }}
          </span>
          <span class="dropdown__email">{{ user.email }}</span>
          <button rds-text-button (click)="logout()">Logout</button>
        </div>
      </div>
    }
    @if (isCompact()) {
      <button
        rds-icon-button
        size="m"
        class="nav-toggle"
        [attr.aria-label]="
          isNavDrawerOpen() ? 'Close navigation menu' : 'Open navigation menu'
        "
        [attr.aria-expanded]="isNavDrawerOpen()"
        (click)="toggleNavDrawer()">
        <rds-icon namespace="outlined" icon="menu"></rds-icon>
      </button>
    }
  </rds-header-actions>
</rds-header>
<rds-drawer-container class="main-panel">
  <!--
    rds-drawer-container requires an rds-drawer child, so the drawer stays
    mounted at every breakpoint. On desktop it is empty and closed, which
    keeps the nav from being rendered twice.
  -->
  <rds-drawer
    class="nav-drawer"
    mode="overlay"
    position="end"
    size="s"
    [expanded]="isNavDrawerOpen()"
    (closeDrawer)="closeNavDrawer()">
    @if (isCompact()) {
      <bad-dashboard-nav [role]="role" [inDrawer]="true"></bad-dashboard-nav>
      @if (user) {
        <rds-divider></rds-divider>
        <div class="drawer-user">
          <span class="drawer-user__name">{{ user.name }}</span>
          <span class="drawer-user__email">{{ user.email }}</span>
          <button rds-secondary-button size="s" (click)="logout()">
            <rds-icon icon="power_standby" namespace="filled" />
            Logout
          </button>
        </div>
      }
    }
  </rds-drawer>
  <rds-drawer-content>
    <div class="main-panel__body">
      @if (!isCompact()) {
        <bad-dashboard-nav
          [role]="role"
          [collapsed]="showChartsMenu()"></bad-dashboard-nav>
      }
      <bsh-chart-filter-menu
        [ngStyle]="
          showChartsMenu() ? { display: 'initial' } : { display: 'none' }
        "></bsh-chart-filter-menu>
      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
  </rds-drawer-content>
</rds-drawer-container>
